export default "__VITE_ASSET__DHJCKNw$__"